import React, { useState } from "react";
import brochureUrl from "../../assets/ansal.pdf";
import "./AboutSection.css";

const AboutSection = ({ onRequestBrochure }) => {
  const handleClick = () => {
    onRequestBrochure?.(brochureUrl, "ansal.pdf");
  };

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-layout">
          {/* Left Content */}
          <div className="about-content">
            <div className="about-header">
              <h2 className="about-title">
                Ansal Esencia{" "}
                <span className="highlight">Sovereign Floors</span>
              </h2>
              <p className="about-subtitle">Sector 67, Gurgaon</p>
            </div>

            <div className="about-text">
              <p>
                Ansal Esencia Sovereign Floors are situated in sector 67, Golf
                Course Extension Road, Gurgaon. Ansal Esencia offers 3 BHK
                independent builder premium floors built on a plot size of 251
                Sq.Yds. Features include air conditioning in living room and
                bedrooms, modular woodwork in bedrooms, modular kitchen,
                landscaped terrace/garden, and many other amenities. The
                mid-segment Sovereign Floors incorporate ADARSH recommendations
                and have been rated under GRIHA for sustainable living.
              </p>

              <p>
                Buy Ansal Esencia floors in resale at the best price through our
                professionally managed real estate company. Specifications
                include: Ground Floor + Basement (2,491sq.ft.) with landscaped
                lawn; First/Second Floor (1,394sq.ft.); Second Floor with
                landscaped terrace lawn; almirahs in all bedrooms;
                air-conditioned floors with 6 KVA power back; fully furnished
                modular kitchen with chimney & hobb; bathrooms with geysers &
                exhaust fans; 6 KVA genset power backup; video phones and sensor
                lights; in vicinity of three life-size theme parks. Call +91
                9999063322 for the best deal in Ansal Esencia floors Gurgaon.
              </p>
            </div>

            <div className="about-actions">
              <button
                className="btn btn--primary btn--lg about-download"
                onClick={handleClick}
                aria-label="Download brochure"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download Brochure
              </button>
            </div>

            {/* Key Features */}
            <div className="key-features">
              <h3>Key Features</h3>
              <div className="features-grid">
                <div className="feature-item">
                  <div className="feature-icon">🏠</div>
                  <div className="feature-text">
                    <h4>3 BHK Premium Floors</h4>
                    <p>Independent builder floors with modern amenities</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">📐</div>
                  <div className="feature-text">
                    <h4>251 Sq.Yds Plot</h4>
                    <p>Spacious plot size with landscaped areas</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">❄️</div>
                  <div className="feature-text">
                    <h4>Fully Air Conditioned</h4>
                    <p>AC in living room and all bedrooms</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">🔌</div>
                  <div className="feature-text">
                    <h4>Power Backup</h4>
                    <p>6 KVA genset power backup</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">🌿</div>
                  <div className="feature-text">
                    <h4>GRIHA Rated</h4>
                    <p>Sustainable living with green features</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">🏌️</div>
                  <div className="feature-text">
                    <h4>Prime Location</h4>
                    <p>Golf Course Extension Road, Sector 67</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
